export enum QuoteStatus {
    QuoteApproved = 'QA'
    , QuotePending = 'PA'
    , QuoteDraft = 'QD'
    , QuoteRevision = 'RR'
    , QuoteExpired = 'QE'
}


// WEBPACK FOOTER //
// ./src/enums/quotestatus.enum.ts